import { ChartViewMode } from 'features/dashboard/ts/ChartViewMode';
import { LinearGraphQueryStep } from 'features/dashboard/ts/LinearGraphQuery';

const dict = {
  [ChartViewMode.Daily]: 'hour',
  [ChartViewMode.Monthly]: 'week',
  [ChartViewMode.Weekly]: 'day',
} as Record<ChartViewMode, LinearGraphQueryStep>;

export const chartModeToStep = (mode: ChartViewMode): LinearGraphQueryStep => dict[mode];
